// Historial de actualizaciones de la app (changelog).
// Fuente única de verdad del número de versión: el primer elemento es la versión actual.
// Para publicar una versión: agregá una entrada ARRIBA del array y subí "version" en package.json.
//
// type por ítem: 'added' | 'improved' | 'fixed'
export const changelog = [
  {
    version: '1.0.0',
    date: '2026-06-17',
    title: 'GIOR ahora es instalable',
    summary: 'Convertimos la app en PWA: instalala en tu celular y úsala como una app nativa.',
    items: [
      { type: 'added', text: 'Instalá GIOR en iPhone y Android desde el navegador.' },
      { type: 'added', text: 'Carga más rápida y arranque tipo app gracias al cacheo de la interfaz.' },
      { type: 'improved', text: 'Las actualizaciones se aplican solas: siempre ves la última versión.' }
    ]
  }
]

// Versión actual derivada del changelog (no duplicar el número a mano).
export const APP_VERSION = changelog[0]?.version || '0.0.0'
